module.exports = __webpack_public_path__ + "img/step9-c.d0ddce14.png";